export const noIndex = {
  meta: [{name: 'robots', content: 'noindex'}],
};
